// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_im-0";
export var animationContainer = "_im-1";
export var modalContent = "_im-2";
export var orderName = "_im-3";
export var refundOption = "_im-4";
export var refundOptionsContainer = "_im-5";